<!--
 * @Author: iRuxu
 * @Date: 2022-05-05 01:50:05
 * @LastEditTime: 2022-07-22 00:26:17
 * @Description:
-->
<template>
    <router-view />
</template>

<script>
export default {
    name: "App",
    props: [],
    data: function () {
        return {};
    },
    computed: {},
};
</script>

<style lang="less">
@import "./assets/css/app.less";
</style>
